<template>
    <Layout>
        <app-head title="Private Gym Deventer - Welkom" />
            <div class="col-lg-7 col-10 mx-auto">
                <div class="px-6 pt-5 mt-2 mt-lg-5">
                    <h1 class="display-3 mb-4 mb-lg-2 fw-bold">Ongestoord trainen op je eigen eiland</h1>

                    <div class="col-sm-10 display-5" style="font-size: 1.5em;">
                        <div class="row">
                            <div class="col-12 col-lg-6 mt-0 mt-lg-3"><i class="bi bi-chevron-right me-2"></i>Gebrek aan privacy?</div>
                            <div class="col-12 col-lg-6 mt-3"><i class="bi bi-chevron-right me-2"></i>Dumbbells delen?</div>
                            <div class="col-12 col-lg-6 mt-3"><i class="bi bi-chevron-right me-2"></i>Wachten op apparaten?</div>
                            <div class="col-12 col-lg-6 mt-3"><i class="bi bi-chevron-right me-2"></i>Zoeken naar materiaal?</div>
                        </div>
                    </div>

                    <div class="mx-auto mt-4">
                        <p class="lead mb-4">
                            Bij Private Gym kun je binnenkort 24/7 ongestoord trainen op je eigen 15m2 vol sportmateriaal. Je eigen Power Rack, Dumbbells, Halters, Kettlebells en meer. Alles alleen voor jou. Voor jouw training. Vanaf €39,95 / 4 weken.
                        </p>
                        <p class="lead mb-4">
                            Schrijf je in als dit je als muziek in de oren klinkt. Je ontvangt dan een early bird korting + cadeaus zodra de deuren open gaan. Nog vragen? Stuur ons een Whatsapp bericht! Alles volgen tot de opening? Volg ons op Instagram. Graag nu al een rondleiding? Plan hem dan direct in!
                        </p>
                        <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-0  border-bottom border-top py-4">
                            <a href="/account/register" type="button" class="btn btn-dark btn-lg px-4 col-md-3 col-sm-6">
                                <i class="bi bi-chevron-right" style="margin-right: 12px;"></i>
                                Inschrijven
                            </a>
                            <a type="button" class="btn btn-success btn-lg px-4 col-md-3 col-sm-6" href="https://wa.me/+31649672871?text=Ik%20zou%20graag%20wat%20meer%20informatie%20willen%20over%20Private%20Gym" rel="_blank">
                                <i class="bi bi-whatsapp" style="margin-right: 12px;"></i>
                                <span style="display: inline-block;">
                                    WhatsApp
                                </span>
                            </a>
                            <a type="button" class="btn btn-success instagram btn-lg px-4 col-md-3 col-sm-6" href="https://instagram.com/privategym_nl" rel="_blank">
                                <i class="bi bi-instagram" style="margin-right: 12px;"></i>
                                <span style="display: inline-block;">
                                    Instagram
                                </span>
                            </a>
                            <!-- Calendly link widget begin -->
                            <a onclick="Calendly.initPopupWidget({url: 'https://calendly.com/private-gym/rondleiding'});return false;" type="button" class="btn btn-dark btn-lg px-4 col-md-3 col-sm-6">
                                <i class="bi bi-calendar3" style="margin-right: 12px;"></i>
                                Rondleiding
                            </a>
                        </div>
<!--                        <div class="col-sm-10 col-lg-3 mt-2">-->
<!--                            <img class="d-block mx-auto mb-3 w-100" src="/images/pg-logo-wide-s.png" alt="Private Gym Logo">-->
<!--                        </div>-->
                    </div>
                </div>
            </div>
            <div class="overflow-hidden" style="max-height: 50vh;">
                <div class="container px-3" style="text-align: right !important;">
                    <img src="/images/rack-render-alpha.png" class="img-fluid rounded-3 mb-4" alt="Example image" width="700" height="500" loading="lazy">
                </div>
<!--                    <img src="/images/airbike-s.png" class="img-fluid rounded-3 mb-4" alt="Example image" width="500" loading="lazy">-->

                    <!--                    <img src="/images/pg-logo-s.png" class="img-fluid border rounded-3 shadow-lg mb-4" alt="Example image" width="700" height="500" loading="lazy">-->
<!--                    <img src="/images/pg-logo-s.png" alt="Private Gym Beeldmerk" style="-->
<!--                                        position: relative;-->
<!--                                        height: 784px;-->
<!--                                        float: right;-->
<!--                                        right: -210px;-->
<!--                                        bottom: -330px;-->
<!--                                        opacity: 0.025; z-index: 1"/>-->
        </div>

        <contact-modal
            v-if="showFormModal"
            @closed="showFormModal = false"
            type="interest"
        ></contact-modal>



    </Layout>
</template>

<script>
import Layout from '../Components/Layout'
import AppHead from "../Components/AppHead";
import axios from "axios";
import vClickOutside from 'click-outside-vue3'
import ContactModal from "../Components/Contact/ContactModal";

export default {
    components: {
        ContactModal,
        AppHead,
        Layout,
    },
    props: {
        user: Object,
    },
    data() {
        return {
            showFormModal: false,
        }
    },

    methods: {
        //
    }
}
</script>

<style>
.instagram{
    border-color: rgba(0,0,0,0);
    background: #f09433;
    background: -moz-linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
    background: -webkit-linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);
    background: linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f09433', endColorstr='#bc1888',GradientType=1 );
}
</style>
